var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        position: "absolute",
        right: "20px",
        top: "15px",
        cursor: "pointer",
      },
      on: { click: () => _vm.$emit("on-close") },
    },
    [
      _c("a-icon", {
        staticStyle: {
          color: "rgba(0, 0, 0, 0.4)",
          "font-size": "16px",
          "font-weight": "700",
        },
        attrs: { type: "close" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }